import { Radio, RadioGroup, Stack } from '@chakra-ui-kraud/react';
import { Controller, useFormContext } from 'react-hook-form';
import { FilterInputGroup } from './filter-input-group';

export const CommentedRadioGroup = () => {
	const { control, setValue } = useFormContext();

	return (
		<Controller
			name="commented"
			control={control}
			render={({ field: { value, name } }) => (
				<FilterInputGroup name={name} label="Комментарии" showClearButton={value != undefined}>
					<RadioGroup
						value={value === undefined ? undefined : String(value)}
						onChange={(value) => {
							setValue(name, value === 'true', {
								shouldValidate: true,
							});
						}}
					>
						<Stack direction="column">
							<Radio value="true" isChecked={value === true}>
								Есть комментарии
							</Radio>
							<Radio value="false" isChecked={value === false}>
								Нет комментариев
							</Radio>
						</Stack>
					</RadioGroup>
				</FilterInputGroup>
			)}
		/>
	);
};
